import React, { Component } from "react";
import {
  Row,
  Col,
  Icon,
  Form,
  Select,
  Upload,
  Button,
  Input,
  Spin,
} from "antd";
import BraftEditor from "braft-editor";
import { ContentUtils } from "braft-utils";
import "braft-editor/dist/index.css";
import PropTypes from "prop-types";
import { app, config, api } from "../app";

const Option = Select.Option;
const FormItem = Form.Item;

/**
 * 上传之前
 * @param file
 */
function beforeUpload(file) {
  const isLt2M = file.size / 1024 / 1024 < 2;
  if (!isLt2M) {
    app.alert("图片最大2MB！", "error");
    return Promise.reject(false);
  }
  return Promise.resolve(true);
}

/**
 * 上传之前2
 * @param file
 */
function beforeUpload2(file) {
  const isLt2M = file.size / 1024 / 1024 < 2,
    types = ["image/png", "image/jpeg", "image/gif", "image/webp"];
  if (!isLt2M) {
    app.alert("图片最大2MB！", "error");
    return Promise.reject(false);
  } else if (types.indexOf(file.type) === -1) {
    app.alert("仅支持上传【.png, .jpg, .gif】！", "error");
    return Promise.reject(false);
  }

  return Promise.resolve(true);
}

class NewsAdd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      levelList: [],
      objList: [],
      editData: {},
      team_id: "",
      teamname: "",
      detailData: {},
    };
  }

  async componentDidMount() {
    this._isMounted = true;
    if (this.props.isDo && this.props.edit_id) {
      await this.handleDetailDatas(this.props.edit_id);
    } else if (this.props.edit_id) {
      await this.handleDetailData(this.props.edit_id);
    }

    (this.state.team_id = this.props.team_id),
      (this.state.teamname = this.props.teamname);
    // await this.handleNewsLevelData()
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  setData = (data) => app.setStateSync(this, data);

  /**
   * 打开详情
   */
  handleDetailData = async (id) => {
    await this.setData({ detail_loading: true });
    let { detailData } = this.state;
    let { flag, data, msg } = await app.post(api.companyDetails, {
      company_id: id,
      indexno: app.getData("indexno"),
      account: app.getData("account"),
    });
    if (flag !== 1) {
      app.alert(msg, "error");
    }
    detailData = data;
    this.setData({ detailData });
    // await app.sleep(2000);
    await this.setData({
      detail_loading: false,
      obj: data,
    });
  };

  // 审核详情
  handleDetailDatas = async (id) => {
    await this.setData({ detail_loading: true });
    let { detailData } = this.state;
    let { flag, data, msg } = await app.post(api.NewsDetails, {
      audit_id: id,
      indexno: app.getData("indexno"),
      account: app.getData("account"),
    });
    if (flag !== 1) {
      app.alert(msg, "error");
    }
    detailData = data;
    this.props.form.setFieldsValue({
      company_img: [
        {
          uid: "-1",
          name: "mien.png",
          status: "done",
          response: {
            flag: 1,
            data: { url: data.company_img },
          },
          url: config.imgUrl + data.company_img,
        },
      ],
    });
    this.setData({ detailData });
    // await app.sleep(2000);
    await this.setData({
      detail_loading: false,
      news_content: data.news_content,
      news_title: data.news_title,
      company_img: data.company_img,
    });
  };

  /**
   * 编辑器图片上传
   * @param file
   * @returns {boolean}
   */
  editorUploadHandler = ({ file }) => {
    if (!file) {
      return false;
    }
    if (file.status === "done" && file.response && file.response.flag === 1) {
      this.props.form.setFieldsValue({
        news_content: ContentUtils.insertMedias(
          this.props.form.getFieldValue("news_content"),
          [
            {
              type: "IMAGE",
              url: config.imgUrl + file.response.data.url,
            },
          ]
        ),
      });
    } else if (file.status === "error") {
      app.alert("上传失败", "error");
    }
  };

  /**
   * 预览
   */
  handlePreview = () => {
    const html = this.props.form.getFieldValue("news_content").toHTML();
    console.log(html);
    if (!html || html === "<p></p>") {
      app.alert("您填写内容后才可预览！", "warn");
      return;
    }
    if (window.previewWindow) {
      window.previewWindow.close();
    }
    window.previewWindow = window.open();
    window.previewWindow.document.write(html);
    window.previewWindow.document.close();
  };

  /**
   * 预览HTML
   **/
  buildPreviewHtml = (html) => {
    return `
              <!Doctype html>
              <html>
                <head>
                  <title>预览内容</title>
                  <style>
                    html,body{
                      height: 100%;
                      margin: 0;
                      padding: 0;
                      overflow: auto;
                      background-color: #f1f2f3;
                    }
                    .container{
                      box-sizing: border-box;
                      width: 1000px;
                      max-width: 100%;
                      min-height: 100%;
                      margin: 0 auto;
                      padding: 30px 20px;
                      overflow: hidden;
                      background-color: #fff;
                      border-right: solid 1px #eee;
                      border-left: solid 1px #eee;
                    }
                    .container img,
                    .container audio,
                    .container video{
                      max-width: 100%;
                      height: auto;
                    }
                    .container p{
                      white-space: pre-wrap;
                      min-height: 1em;
                    }
                    .container pre{
                      padding: 15px;
                      background-color: #f1f1f1;
                      border-radius: 5px;
                    }
                    .container blockquote{
                      margin: 0;
                      padding: 15px;
                      background-color: #f1f1f1;
                      border-left: 3px solid #d1d1d1;
                    }
                  </style>
                </head>
                <body>
                  <div class="container">${html}</div>
                </body>
              </html>
            `;
  };

  /**
   * 提交
   **/
  handleAdd = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll(async (err, values) => {
      if (!err) {
        await this.setData({ submit_loading: false });
        if (
          values.company_img &&
          values.company_img[0] &&
          values.company_img[0].response &&
          values.company_img[0].response.flag === 1
        ) {
          values.company_img = values.company_img[0].response.data.url;
        } else {
          values.company_img = "";
        }
        values.indexno = app.getData("indexno");
        values.account = app.getData("account");
        values.news_content = values.news_content.toHTML();
        values.team_id = this.state.team_id;
        (values.type = 1), (values.version_id = api.version_id);
        const { edit_id, team_id } = this.props;
        let result = {};
        if (edit_id) {
          values.news_id = edit_id;
          result = await app.post(api.NewsEdit, values);
        } else {
          result = await app.post(api.NewsAdd, values);
        }
        if (result.flag === 1) {
          app.alert("提交成功", "success");
          this.props.onClose(true);
        } else {
          app.alert(result.msg || "提交失败", "error");
        }
      }
    });
  };

  /**
   * 获取动态级别
   * @returns {Promise<void>}
   */
  handleNewsLevelData = async () => {
    let params = {
        indexno: app.getData("indexno"),
        account: app.getData("account"),
      },
      { flag, data, msg } = await app.post(api.Newslevel, params);
    if (flag !== 1) {
      data = [];
      app.alert(msg, "error");
    }
    await this.setData({ levelList: data });
  };
  renderRecommend() {
    const { detailData } = this.state;
    
    if (!detailData || !detailData.recommend) {
      return null; // 或者返回其他默认的内容
    }
    
    const formattedRecommend = detailData.recommend.replace(/\n/g, "<br>");
    
    return (
      <p dangerouslySetInnerHTML={{ __html: formattedRecommend }}></p>
    );
  }
  /**
   * 获取动态对象
   * @returns {Promise<void>}
   */
  handleNewsObjectData = async (level) => {
    if (level && level === "1") return;
    await this.setData({ obj_loading: true });
    this.props.form.setFieldsValue({ object: undefined });
    let params = {
        level,
        indexno: app.getData("indexno"),
        account: app.getData("account"),
      },
      { flag, data, msg } = await app.post(api.NewsReleaseObject, params);
    if (flag !== 1) {
      data = [];
      app.alert(msg, "error");
    }
    await this.setData({ objList: data, obj_loading: false });
  };

  render() {
    let formItemLayout = {
        labelCol: { span: 3 },
        wrapperCol: { span: 6 },
      },
      { edit_id, team_id, teamname } = this.props,
      { getFieldDecorator, getFieldsValue } = this.props.form,
      {
        levelList,
        obj_loading,
        objList,
        detail_loading,
        editData,
        news_content,
        detailData,
        news_title,
        obj,
        company_img,
      } = this.state,
      formData = getFieldsValue(["company_img", "object_type"]);
    const excludeControls = ["media", "emoji", "code"],
      extendControls = [
        {
          key: "custom-button",
          type: "button",
          text: "预览",
          onClick: this.handlePreview,
        },
        {
          key: "antd-uploader",
          type: "component",
          component: (
            <Upload
              accept="image/png,image/jpeg,image/gif"
              showUploadList={false}
              action={config.serverUrl + api.ImageUpload}
              beforeUpload={beforeUpload2}
              data={{
                token: app.getData("token"),
                indexno: app.getData("indexno"),
                account: app.getData("account"),
                upload_type: "news",
              }}
              name="image"
              onChange={(file) => this.editorUploadHandler(file)}
            >
              {/* 这里的按钮最好加上type="button"，以避免在表单容器中触发表单提交，用Antd的Button组件则无需如此 */}
              <button
                type="button"
                className="control-item button upload-button"
                data-title="插入图片"
              >
                <Icon type="picture" theme="filled" />
              </button>
            </Upload>
          ),
        },
      ];
    return (
      <div>
        {detail_loading ? (
          <div style={{ textAlign: "center" }}>
            <Spin size="large" />
          </div>
        ) : null}
        <Form onSubmit={this.handleAdd} hidden={detail_loading}>
          {/* {edit_id && (
            <div
              style={{
                padding: 10,
                border: "1px gray dashed",
                width: "50%",
                margin: "0 auto",
                display: "flex",
              }}
            >
              {detailData.audit_status == 0 ? (
                <p> 审核状态： {detailData.audit_name}</p>
              ) : (
                <div>
                  <p>审核人： {detailData.audit_admin}</p>
                  <p>审核状态： {detailData.audit_name}</p>
                  <p>审核时间： {detailData.audit_time}</p>
                  {detailData.detail && (
                    <p style={{ display: "flex" }}>
                      {" "}
                      <span style={{ width: "75px" }}>审核原因：</span>{" "}
                      <span style={{ color: "red", flexWrap: "wrap", flex: 1 }}>
                        {detailData.detail}
                      </span>
                    </p>
                  )}
                </div>
              )}
            </div>
          )} */}
            <FormItem
            label="所属队伍"
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 19 }}
          >
            <p>{detailData.teamname}</p>
          </FormItem>
          <FormItem {...formItemLayout} label="门面照">
            <img
              width={80}
              height={80}
              src={config.imgUrl + detailData.company_img}
            />
          </FormItem>
          <FormItem
            label="企业类型"
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 19 }}
          >
            <p>{detailData.class_name}</p>
          </FormItem>
          <FormItem
            label="企业名称"
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 19 }}
          >
            <p>{detailData.company_name}</p>
          </FormItem>
          <FormItem
            label="联系人"
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 19 }}
          >
            <p>{detailData.linkman}</p>
          </FormItem>
          <FormItem
            label="联系方式"
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 19 }}
          >
            <p>{detailData.linkman_mobile}</p>
          </FormItem>
          <FormItem
            label="企业爱心值"
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 19 }}
          >
            <p>{detailData.love_value}</p>
          </FormItem>
          <FormItem
            label="企业地址"
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 19 }}
          >
            <p>{detailData.location}</p>
          </FormItem>
          <FormItem
            label="企业简介"
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 19 }}
          >
            {this.renderRecommend()}
          </FormItem>
        </Form>
      </div>
    );
  }
}

NewsAdd.propTypes = {
  edit_id: PropTypes.any,
};

export default Form.create()(NewsAdd);



// WEBPACK FOOTER //
// ./src/components/EnterpriseDetails.jsx